interface NumberFormatterProps {
  className?: string;
  number: number;
  postfix?: string;
}

const NumberFormatter = ({ className, number, postfix }: NumberFormatterProps) => {
  const formattedNumber = number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return <span className={className}>{formattedNumber}{postfix}</span>;
};

export default NumberFormatter;
